import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import '../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../node_modules/lit-element/lit-element.js';
import { css as r } from '../../../../../node_modules/@lit/reactive-element/css-tag.js';

var css_248z = r`:host([isGroupsite]) article{align-items:stretch!important}@media (min-width:1024px){:host([isGroupsite]) article{justify-content:center}}@media (min-width:1024px){:host([isGroupsite]) .img-container{max-height:500px!important;min-height:320px!important;padding-top:0!important;width:35%!important}}`;

export { css_248z as default };
